import {
    fabAppStore,
    fabFacebook,
    fabGooglePlay,
    fabInstagram,
    fabPagelines,
    fabTiktok,
    fabViber,
    fabVk,
    fabWhatsapp,
    fabYoutube,
    farBell,
    farCheckCircle,
    farClock,
    farCommentDots,
    farEnvelope,
    farNewspaper,
    fasAngleDown,
    fasArrowLeft,
    fasBars,
    fasBell,
    fasBorderAll,
    fasCaretDown,
    fasCaretRight,
    fasCheck,
    fasChevronCircleDown,
    fasChevronCircleRight,
    fasChevronDown,
    fasChevronUp,
    fasCircle,
    fasExclamationCircle,
    fasExclamationTriangle,
    fasExpand,
    fasInfoCircle,
    fasList,
    fasMapMarker,
    fasMapMarkerAlt,
    fasMinus,
    fasPercent,
    fasPercentage,
    fasPlus
} from '@quasar/extras/fontawesome-v5'

import {evaHomeOutline, evaInfoOutline, evaMinus} from '@quasar/extras/eva-icons'
import {
    mdiAccountCircleOutline,
    mdiAccountSearchOutline,
    mdiBowlMixOutline,
    mdiBriefcaseAccountOutline,
    mdiBullhornOutline,
    mdiCardsHeartOutline,
    mdiChevronLeft,
    mdiChevronRight,
    mdiClockOutline,
    mdiClockTimeEightOutline,
    mdiCreditCardOutline,
    mdiGiftOutline,
    mdiGrid,
    mdiHandCoinOutline,
    mdiHelpCircleOutline,
    mdiHumanDolly,
    mdiLogout,
    mdiMapMarkerMultipleOutline,
    mdiMapMarkerOutline,
    mdiPencil,
    mdiPhoneRefreshOutline,
    mdiRefresh,
    mdiSackPercent,
    mdiShoppingOutline,
    mdiSilverwareForkKnife,
    mdiStarOutline,
    mdiTruckFastOutline,
    mdiTruckOutline,
    mdiVideoOutline
} from '@quasar/extras/mdi-v6'

import {
    matAttachMoney,
    matBadge,
    matBolt,
    matBrowserNotSupported,
    matBugReport,
    matCancel,
    matCasino,
    matCategory,
    matCheck,
    matCheckCircle,
    matCheckCircleOutline,
    matChevronLeft,
    matChevronRight,
    matContentCopy,
    matErrorOutline,
    matFastfood,
    matFiberNew,
    matFlag,
    matFullscreen,
    matGridView,
    matHistory,
    matHome,
    matInbox,
    matInfo,
    matInstallMobile,
    matLocalOffer,
    matLocalShipping,
    matLogin,
    matMailOutline,
    matMarkEmailUnread,
    matMoreHoriz,
    matMoreVert,
    matNotifications,
    matNotificationsActive,
    matNotificationsNone,
    matNotificationsOff,
    matPause,
    matPeople,
    matPersonOutline,
    matPlayArrow,
    matRadioButtonChecked,
    matRadioButtonUnchecked,
    matRestaurant,
    matSchedule,
    matSearch,
    matShare,
    matStop,
    matStopCircle,
    matStore,
    matWarning,
    matClose,
    matFavorite,
    matFavoriteBorder,
    matOpenInBrowser
} from '@quasar/extras/material-icons'

export const ICONS = {
    // === SITE ===
    avatar: 'M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18ZM5 10H7C7 10.7956 7.31607 11.5587 7.87868 12.1213C8.44129 12.6839 9.20435 13 10 13C10.7956 13 11.5587 12.6839 12.1213 12.1213C12.6839 11.5587 13 10.7956 13 10H15C15 11.3261 14.4732 12.5979 13.5355 13.5355C12.5979 14.4732 11.3261 15 10 15C8.67392 15 7.40215 14.4732 6.46447 13.5355C5.52678 12.5979 5 11.3261 5 10Z|0 0 20 20',
    star: mdiStarOutline,

    // === NAVIGATION & ARROWS ===
    home: matHome,
    arrowLeft: fasArrowLeft,
    caretDown: fasCaretDown,
    caretRight: fasCaretRight,
    carouselArrowLeft: mdiChevronLeft,
    carouselArrowRight: mdiChevronRight,
    chevronCircleDown: fasChevronCircleDown,
    chevronCircleRight: fasChevronCircleRight,
    chevronDown: fasChevronDown,
    chevronLeft: 'M8 16L0 8L8 0L9.5 1.5L3 8L9.5 14.5L8 16Z|0 0 10 16',
    chevronLeftMat: matChevronLeft,
    chevronRight: 'M1.5 0L9.5 8L1.5 16L0 14.5L6.5 8L0 1.5L1.5 0Z|0 0 10 16',
    chevronRightMat: matChevronRight,
    chevronUp: fasChevronUp,
    playArrow: matPlayArrow,

    // === ACTIONS ===
    cancel: matCancel,
    check: matCheck,
    checkAlt: 'M2.43314 5.47064C2.04009 5.06418 1.38849 5.06418 0.995429 5.47064L0.672241 5.80484C0.297384 6.19248 0.297383 6.80752 0.672241 7.19516L5.90578 12.6071C6.10993 12.8182 6.45118 12.8088 6.64332 12.5867L15.4014 2.46456C15.7403 2.07292 15.724 1.48737 15.364 1.11508L15.054 0.794512C14.6427 0.369155 13.954 0.392022 13.5718 0.843728L6.28571 9.45455L2.43314 5.47064Z|0 0 16 13',
    checkCircle: matCheckCircle,
    checkCircleAlt: farCheckCircle,
    checkCircleOutline: matCheckCircleOutline,
    checkSolid: fasCheck,
    close: matClose,
    copy: 'M2.86177 2.86195C2.98679 2.73692 3.15636 2.66669 3.33317 2.66669H10.8332C11.01 2.66669 11.1796 2.73692 11.3046 2.86195C11.4296 2.98697 11.4998 3.15654 11.4998 3.33335V4.16669C11.4998 4.71897 11.9476 5.16669 12.4998 5.16669C13.0521 5.16669 13.4998 4.71897 13.4998 4.16669V3.33335C13.4998 2.62611 13.2189 1.94783 12.7188 1.44774C12.2187 0.947639 11.5404 0.666687 10.8332 0.666687H3.33317C2.62593 0.666687 1.94765 0.947638 1.44755 1.44774C0.947455 1.94783 0.666504 2.62611 0.666504 3.33335V10.8334C0.666504 11.5406 0.947455 12.2189 1.44755 12.719C1.94765 13.2191 2.62593 13.5 3.33317 13.5H4.1665C4.71879 13.5 5.1665 13.0523 5.1665 12.5C5.1665 11.9477 4.71879 11.5 4.1665 11.5H3.33317C3.15636 11.5 2.98679 11.4298 2.86177 11.3048C2.73674 11.1797 2.6665 11.0102 2.6665 10.8334V3.33335C2.6665 3.15654 2.73674 2.98697 2.86177 2.86195Z&&M9.16667 6.5C7.69391 6.5 6.5 7.69391 6.5 9.16667V16.6667C6.5 18.1394 7.69391 19.3333 9.16667 19.3333H16.6667C18.1394 19.3333 19.3333 18.1394 19.3333 16.6667V9.16667C19.3333 7.69391 18.1394 6.5 16.6667 6.5H9.16667ZM8.5 9.16667C8.5 8.79848 8.79848 8.5 9.16667 8.5H16.6667C17.0349 8.5 17.3333 8.79848 17.3333 9.16667V16.6667C17.3333 17.0349 17.0349 17.3333 16.6667 17.3333H9.16667C8.79848 17.3333 8.5 17.0349 8.5 16.6667V9.16667Z@@fill-rule:evenodd;clip-rule:evenodd|0 0 20 20',
    expand: fasExpand,
    minus: 'M -0.009 7.855 C -0.009 7.303 0.439 6.855 0.991 6.855 L 14.991 6.855 C 15.544 6.855 15.991 7.303 15.991 7.855 C 15.991 8.408 15.544 8.855 14.991 8.855 L 0.991 8.855 C 0.439 8.855 -0.009 8.408 -0.009 7.855 Z|0 0 16 16',
    minusAlt: evaMinus,
    minusSolid: fasMinus,
    pause: matPause,
    pencil: 'M16.3998 3.33998L13.6598 0.59998C13.3022 0.264076 12.8336 0.0713388 12.3431 0.058432C11.8527 0.0455252 11.3746 0.213349 10.9998 0.52998L1.99981 9.52998C1.67657 9.85594 1.47531 10.2832 1.42981 10.74L0.999808 14.91C0.986337 15.0564 1.00534 15.2041 1.05547 15.3424C1.1056 15.4806 1.18561 15.6062 1.28981 15.71C1.38325 15.8027 1.49406 15.876 1.6159 15.9258C1.73774 15.9755 1.8682 16.0007 1.99981 16H2.08981L6.25981 15.62C6.71661 15.5745 7.14384 15.3732 7.46981 15.05L16.4698 6.04998C16.8191 5.68095 17.0079 5.18849 16.9948 4.68052C16.9817 4.17254 16.7677 3.69049 16.3998 3.33998ZM6.07981 13.62L3.07981 13.9L3.34981 10.9L8.99981 5.31998L11.6998 8.01998L6.07981 13.62ZM12.9998 6.67998L10.3198 3.99998L12.2698 1.99998L14.9998 4.72998L12.9998 6.67998Z|0 0 17 16',
    pencilAlt: mdiPencil,
    play: 'M7.765 5.47817C7.43197 5.27003 7 5.50945 7 5.90217V14.0979C7 14.4906 7.43198 14.7301 7.765 14.5219L14.3216 10.424C14.6349 10.2282 14.6349 9.77188 14.3216 9.57604L7.765 5.47817Z&&M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10Z@@fill-rule:evenodd;clip-rule:evenodd|0 0 20 20',
    plus: 'M8 0C8.5523 0 9 0.44772 9 1V7H15C15.5523 7 16 7.4477 16 8C16 8.5523 15.5523 9 15 9H9V15C9 15.5523 8.5523 16 8 16C7.4477 16 7 15.5523 7 15V9H1C0.44772 9 0 8.5523 0 8C0 7.4477 0.44772 7 1 7H7V1C7 0.44772 7.4477 0 8 0Z|0 0 16 16',
    plusSolid: fasPlus,
    recall: mdiPhoneRefreshOutline,
    refresh: mdiRefresh,
    trush: 'M8.00293 8H6.00293V16H8.00293V8Z&&M12.0029 8H10.0029V16H12.0029V8Z&&M4.00293 20C2.89993 20 2.00293 19.103 2.00293 18V6H0.00292969V4H4.00293V2C4.00293 0.897 4.89993 0 6.00293 0H12.0029C13.1059 0 14.0029 0.897 14.0029 2V4H18.0029V6H16.0029V18C16.0029 19.103 15.1059 20 14.0029 20H4.00293ZM12.0029 2H6.00293V4H12.0029V2ZM14.0039 18L14.0029 6H4.00293V18H14.0039Z@@fill-rule:evenodd;clip-rule:evenodd|0 0 19 20',

    // === UI ELEMENTS ===
    bars: mdiMapMarkerMultipleOutline,
    barsSolid: fasBars,
    borderAll: fasBorderAll,
    circle: fasCircle,
    filters: "M710-150q-63 0-106.5-43.5T560-300q0-63 43.5-106.5T710-450q63 0 106.5 43.5T860-300q0 63-43.5 106.5T710-150Zm0-80q29 0 49.5-20.5T780-300q0-29-20.5-49.5T710-370q-29 0-49.5 20.5T640-300q0 29 20.5 49.5T710-230Zm-550-30v-80h320v80H160Zm90-250q-63 0-106.5-43.5T100-660q0-63 43.5-106.5T250-810q63 0 106.5 43.5T400-660q0 63-43.5 106.5T250-510Zm0-80q29 0 49.5-20.5T320-660q0-29-20.5-49.5T250-730q-29 0-49.5 20.5T180-660q0 29 20.5 49.5T250-590Zm230-30v-80h320v80H480Zm230 320ZM250-660Z@@@@|0 -960 960 960",
    grid: mdiGrid,
    gridView: matGridView,
    humburger: 'M0 1C0 0.44772 0.44772 0 1 0H15C15.5523 0 16 0.44772 16 1C16 1.55228 15.5523 2 15 2H1C0.44772 2 0 1.55228 0 1ZM0 6C0 5.4477 0.44772 5 1 5H15C15.5523 5 16 5.4477 16 6C16 6.5523 15.5523 7 15 7H1C0.44772 7 0 6.5523 0 6ZM0 11C0 10.4477 0.44772 10 1 10H15C15.5523 10 16 10.4477 16 11C16 11.5523 15.5523 12 15 12H1C0.44772 12 0 11.5523 0 11Z|0 0 16 12',
    list: fasList,
    moreHoriz: matMoreHoriz,
    moreVert: matMoreVert,
    radioButtonChecked: matRadioButtonChecked,
    radioButtonUnchecked: matRadioButtonUnchecked,
    search: 'M8.00001 2C4.6863 2 2 4.6863 2 8.00001C2 11.3137 4.6863 14 8.00001 14C11.3137 14 14 11.3137 14 8.00001C14 4.6863 11.3137 2 8.00001 2ZM0 8.00001C0 3.58172 3.58172 0 8.00001 0C12.4183 0 16 3.58172 16 8.00001C16 9.84871 15.3729 11.551 14.3199 12.9056L19.7071 18.2929C20.0976 18.6834 20.0976 19.3166 19.7071 19.7071C19.3166 20.0976 18.6834 20.0976 18.2929 19.7071L12.9056 14.3199C11.551 15.3729 9.84871 16 8.00001 16C3.58172 16 0 12.4183 0 8.00001Z|0 0 20 20',
    searchAlt: matSearch,
    sort: 'M3 18H9V16H3V18ZM3 6V8H21V6H3ZM3 13H15V11H3V13Z|0 0 24 24',

    // === NOTIFICATIONS ===
    bell: farBell,
    bellSolid: fasBell,
    notifications: matNotifications,
    notificationsActive: matNotificationsActive,
    notificationsNone: matNotificationsNone,
    notificationsOff: matNotificationsOff,

    // === SOCIAL MEDIA ===
    facebook: fabFacebook,
    instagram: fabInstagram,
    pagelines: fabPagelines,
    share: matShare,
    telegram: "M30 16 A14 14 0 0 1 16 30 A14 14 0 0 1 2 16 A14 14 0 0 1 30 16 z@@@@&&M22.9866 10.2088C23.1112 9.40332 22.3454 8.76755 21.6292 9.082L7.36482 15.3448C6.85123 15.5703 6.8888 16.3483 7.42147 16.5179L10.3631 17.4547C10.9246 17.6335 11.5325 17.541 12.0228 17.2023L18.655 12.6203C18.855 12.4821 19.073 12.7665 18.9021 12.9426L14.1281 17.8646C13.665 18.3421 13.7569 19.1512 14.314 19.5005L19.659 22.8523C20.2585 23.2282 21.0297 22.8506 21.1418 22.1261L22.9866 10.2088Z@@@@|0 0 32 32",
    tiktok: fabTiktok,
    viber: fabViber,
    vk: fabVk,
    whatsapp: fabWhatsapp,
    yandexZen: 'M0 15C0 7.8203 5.8203 2 13 2V2C20.1797 2 26 7.8203 26 15V15C26 22.1797 20.1797 28 13 28V28C5.8203 28 0 22.1797 0 15V15Z&&M12.7369 2C12.6755 7.34828 12.3258 10.3415 10.3336 12.3336C8.34146 14.3258 5.34828 14.6755 0 14.7369V15.5131C5.34828 15.5745 8.34147 15.9242 10.3336 17.9164C12.2945 19.8773 12.6641 22.808 12.7338 28H13.5162C13.5858 22.808 13.9555 19.8773 15.9164 17.9164C17.8773 15.9555 20.808 15.5858 26 15.5162V14.7338C20.808 14.6641 17.8773 14.2945 15.9164 12.3336C13.9242 10.3415 13.5745 7.34828 13.5131 2H12.7369Z@@fill-rule:evenodd;clip-rule:evenodd;fill:white|0 0 26 30',
    youtube: fabYoutube,


    // === BUSINESS & SHOP ===
    bagShoping: 'm353,161l0,-32c0,-70.58 -57.421,-128 -128,-128c-70.58,0 -128,57.42 -128,128l0,32l-96,0l0,272c0,44.183 35.817,80 80,80l288,0c44.183,0 80,-35.817 80,-80l0,-272l-96,0zm-192,-32c0,-35.29 28.71,-64 64,-64s64,28.71 64,64l0,32l-128,0l0,-32z|0 0 448 512',
    basket: 'M18.4999 7.93804C18.9782 7.66188 19.5899 7.82575 19.866 8.30407L22.577 13H25C25.5523 13 26 13.4477 26 14V15H24.833L24.076 24.083C24.0552 24.3329 23.9413 24.5658 23.7568 24.7357C23.5723 24.9055 23.3308 24.9999 23.08 25H8.92C8.66925 24.9999 8.4277 24.9055 8.24322 24.7357C8.05875 24.5658 7.94481 24.3329 7.924 24.083L7.166 15H6V14C6 13.4477 6.44772 13 7 13H9.422L12.134 8.30388C12.4101 7.82565 13.0217 7.66183 13.5 7.93796C13.9782 8.21411 14.1421 8.82572 13.866 9.30401L11.732 13H20.267L18.1338 9.30395C17.8578 8.82567 18.0217 8.21416 18.4999 7.93804ZM22.826 15H9.173L9.84 23H22.159L22.826 15Z|6 11 20 10',
    bonus: mdiSackPercent,
    casino: matCasino,
    category: matCategory,
    coin: 'M21 6.5C21 8.98528 16.9706 11 12 11C7.02944 11 3 8.98528 3 6.5C3 4.01472 7.02944 2 12 2C16.9706 2 21 4.01472 21 6.5ZM20.4879 10C19.2524 11.7478 15.9187 13 12 13C8.08134 13 4.74763 11.7478 3.51212 10C3.18046 10.4692 3 10.974 3 11.5C3 13.9853 7.02944 16 12 16C16.9706 16 21 13.9853 21 11.5C21 10.974 20.8195 10.4692 20.4879 10ZM12 18C15.9187 18 19.2524 16.7478 20.4879 15C20.8195 15.4692 21 15.974 21 16.5C21 18.9853 16.9706 21 12 21C7.02944 21 3 18.9853 3 16.5C3 15.974 3.18046 15.4692 3.51212 15C4.74763 16.7478 8.08134 18 12 18Z|0 0 24 24',
    coins: mdiHandCoinOutline,
    cutlery: mdiSilverwareForkKnife,
    fastfood: matFastfood,
    favorite: matFavoriteBorder,
    favoriteFilled: matFavorite,
    fire: "M12.0001 0.5C11.6001 0.5 11.2001 0.7 11.0001 1C10.8001 1.3 10.8001 1.7 11.0001 2C11.5001 2.9 12.0001 4 12.0001 5C12.0001 6.7 10.7001 8 9.00006 8C8.60006 8 8.20006 8.2 8.00006 8.5C7.80006 8.8 7.80006 9.2 8.00006 9.5C8.50006 10.4 9.00006 11.5 9.00006 12.5C9.00006 14.2 7.70006 15.5 6.00006 15.5C5.60006 15.5 5.20006 15.7 5.00006 16C4.80006 16.3 4.80006 16.7 5.00006 17C5.50006 17.9 6.00006 19 6.00006 20C6.00006 22.8 8.20006 25 11.0001 25H13.0001C15.8001 25 18.0001 22.8 18.0001 20C18.0001 19 18.5001 17.9 19.0001 17C19.2001 16.7 19.2001 16.3 19.0001 16C18.8001 15.7 18.4001 15.5 18.0001 15.5C16.3001 15.5 15.0001 14.2 15.0001 12.5C15.0001 11.5 15.5001 10.4 16.0001 9.5C16.2001 9.2 16.2001 8.8 16.0001 8.5C15.8001 8.2 15.4001 8 15.0001 8C13.3001 8 12.0001 6.7 12.0001 5C12.0001 4 12.5001 2.9 13.0001 2C13.2001 1.7 13.2001 1.3 13.0001 1C12.8001 0.7 12.4001 0.5 12.0001 0.5Z|0 0 24 26",
    gift: mdiGiftOutline,
    heart: mdiCardsHeartOutline,
    homeOutline: evaHomeOutline,
    promocode: mdiGiftOutline,
    restaurant: mdiSilverwareForkKnife,
    restaurant2: matRestaurant,
    store: matStore,

    // === DELIVERY & LOCATION ===
    delivery: mdiTruckFastOutline,
    local_shipping: mdiTruckFastOutline,
    localShipping: matLocalShipping,
    location: mdiMapMarkerOutline,
    mapMarker: fasMapMarker,
    mapMarkerAlt: fasMapMarkerAlt,
    mapPlacemark: 'M15 31H17V51C17 51.5523 16.5523 52 16 52C15.4477 52 15 51.5523 15 51V31Z@@&&M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16Z@@stroke-width:2;stroke:#ffffff|0 0 32 52',
    pickup: mdiHumanDolly,

    // === PAYMENT ===
    attachMoney: matAttachMoney,
    payment: mdiCreditCardOutline,
    payment_card: 'M15.89.017H2.11C.943.017 0 .927 0 2.048v.18h18v-.18C18 .926 17.056.017 15.89.017z&&M0 10.362c0 1.122.944 2.032 2.11 2.032h13.78c1.166 0 2.11-.91 2.11-2.032V4.26H0v6.102zm12.954-2.73h1.694c.914 0 1.657.716 1.657 1.596 0 .88-.743 1.595-1.657 1.595h-1.694c-.914 0-1.657-.716-1.657-1.595 0-.88.743-1.596 1.657-1.596zm-10.732 0H5.61c.291 0 .527.227.527.508 0 .28-.236.507-.527.507h-3.39a.518.518 0 01-.526-.507c0-.28.236-.508.527-.508zm0 2.176h5.083c.292 0 .528.227.528.507s-.236.508-.528.508H2.222a.518.518 0 01-.527-.508c0-.28.236-.507.527-.507z&&M12.954 9.808h1.694c.333 0 .603-.26.603-.58 0-.32-.27-.58-.603-.58h-1.694a.592.592 0 00-.602.58c0 .32.27.58.602.58z|0 0 18 13',
    payment_cash: 'M12.717 9.764a1.76 1.76 0 00-1.76 1.757c0 .97.788 1.757 1.76 1.757H18V9.764h-5.283zm0 2.343a.586.586 0 110-1.173.586.586 0 010 1.173z&&M12.717 8.592h2.935V6.834c0-.969-.79-1.757-1.76-1.757H.586A.587.587 0 000 5.663v11.716c0 .323.263.586.587.586h13.304c.971 0 1.761-.788 1.761-1.758V14.45h-2.935a2.935 2.935 0 01-2.934-2.929 2.935 2.935 0 012.934-2.93zm3.522-3.515h-.005c.37.49.592 1.098.592 1.757v1.758H18V6.834c0-.969-.79-1.757-1.76-1.757zm.587 9.373v1.757c0 .66-.222 1.268-.592 1.758h.005c.971 0 1.761-.788 1.761-1.758V14.45h-1.174zM9.611.172a.588.588 0 00-.83 0l-.516.515 3.225 3.218h1.862L9.61.172zm-3.522 0a.588.588 0 00-.83 0L1.518 3.905H9.83L6.089.172z|0 0 18 18',
    payment_terminal: 'M10.324 1.953c0-.43.343-.781.764-.781V0H4.206C3.152 0 2.294.876 2.294 1.953V7.11h8.03V1.953zM12.235.392v1.952a.773.773 0 00-.764.781v.508H13v-1.68c0-.638-.3-1.205-.765-1.561z&&M11.47 4.905v3.376H1.148V4.905A1.759 1.759 0 000 6.562v11.68C0 19.212.772 20 1.72 20h9.177c.949 0 1.72-.789 1.72-1.758V6.562c0-.763-.479-1.415-1.146-1.657zM4.13 17.656H2.293v-1.172H4.13v1.172zm0-2.343H2.293V14.14H4.13v1.171zm0-2.344H2.293v-1.172H4.13v1.172zm3.096 4.687H5.391v-1.172h1.835v1.172zm0-2.343H5.391V14.14h1.835v1.171zm0-2.344H5.391v-1.172h1.835v1.172zm3.098 4.687H8.488v-1.172h1.836v1.172zm0-2.343H8.488V14.14h1.836v1.171zm0-2.344H8.488v-1.172h1.836v1.172zm0-2.344h-8.03V9.453h8.03v1.172z|0 0 13 20',

    // === ORDER STATUSES ===
    order_status_A: 'M5273.1,2400.1v-2c0-2.8-5-4-9.7-4s-9.7,1.3-9.7,4v2c0,1.8,0.7,3.6,2,4.9l5,4.9c0.3,0.3,0.4,0.6,0.4,1v6.4     c0,0.4,0.2,0.7,0.6,0.8l2.9,0.9c0.5,0.1,1-0.2,1-0.8v-7.2c0-0.4,0.2-0.7,0.4-1l5.1-5C5272.4,2403.7,5273.1,2401.9,5273.1,2400.1z      M5263.4,2400c-4.8,0-7.4-1.3-7.5-1.8v0c0.1-0.5,2.7-1.8,7.5-1.8c4.8,0,7.3,1.3,7.5,1.8C5270.7,2398.7,5268.2,2400,5263.4,2400z&&M5268.4,2410.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1H5268.4z&&M5272.7,2413.7h-4.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1C5273.7,2414.1,5273.3,2413.7,5272.7,2413.7z&&M5272.7,2417h-4.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1C5273.7,2417.5,5273.3,2417,5272.7,2417z&&M50,2.5C23.8,2.5,2.5,23.8,2.5,50S23.8,97.5,50,97.5S97.5,76.2,97.5,50S76.2,2.5,50,2.5z M50,89.5     c-21.8,0-39.5-17.7-39.5-39.5S28.2,10.5,50,10.5S89.5,28.2,89.5,50S71.8,89.5,50,89.5z&&M55,26.1H40.8c-0.7,0-1.3,0.6-1.3,1.2v20.8h-4.7c-0.7,0-1.3,0.6-1.3,1.3v5.3c0,0.7,0.6,1.2,1.3,1.2h4.7v5.2h-4.7     c-0.7,0-1.3,0.6-1.3,1.2v5.3c0,0.7,0.6,1.3,1.3,1.3h4.7v5.9c0,0.6,0.6,1.2,1.3,1.2h5.3c0.7,0,1.2-0.6,1.2-1.2v-5.9h11.2     c0.7,0,1.2-0.6,1.2-1.3v-5.3c0-0.6-0.5-1.2-1.2-1.2H47.3v-5.2h8.1c8.4,0,15.2-7,14.9-15.4C70,32.4,63.1,26.1,55,26.1z M55.4,48.1     h-8.1V33.9h8.1c4,0,7.1,3.2,7.1,7.1C62.5,44.9,59.4,48.1,55.4,48.1z|0 0 100 100',
    order_status_D: mdiTruckOutline,
    order_status_F: mdiShoppingOutline,
    order_status_K: mdiBowlMixOutline,
    order_status_N: mdiClockTimeEightOutline,
    order_status_O: 'M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z&&M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0|0 0 24 24',
    order_status_P: matCheck,
    order_status_T: 'M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z&&M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0|0 0 24 24',

    // === COMMUNICATION ===
    comment: 'M1.8 0H10.2C10.6774 0 11.1352 0.199624 11.4728 0.554956C11.8104 0.910288 12 1.39222 12 1.89474V8.21053C12 8.71304 11.8104 9.19497 11.4728 9.55031C11.1352 9.90564 10.6774 10.1053 10.2 10.1053H3.93C3.8142 10.1006 3.69958 10.1313 3.6 10.1937L0.906 11.9116C0.813387 11.9694 0.70769 12 0.6 12C0.496927 11.9997 0.395673 11.9714 0.306 11.9179C0.21332 11.8631 0.136147 11.7833 0.0823803 11.6867C0.0286133 11.5902 0.000183214 11.4803 0 11.3684V1.89474C0 1.39222 0.189642 0.910288 0.527208 0.554956C0.864773 0.199624 1.32261 0 1.8 0ZM8.99841 5.09859C8.99908 5.07775 8.99954 5.05685 8.99979 5.0359C8.99993 5.04147 9 5.04705 9 5.05263C9 5.06802 8.99947 5.08335 8.99841 5.09859Z|0 0 12 12',
    commentDots: farCommentDots,
    envelope: farEnvelope,
    mailOutline: matMailOutline,
    megafon: mdiBullhornOutline,
    phone: "M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z@@@@|0 0 512 512",

    // === USER & PROFILE ===
    briefcase: mdiBriefcaseAccountOutline,
    camera: mdiVideoOutline,
    headhunting: mdiAccountSearchOutline,
    login: matLogin,
    logout: mdiLogout,
    people: matPeople,
    person: matPersonOutline,
    profileCircle: mdiAccountCircleOutline,

    // === TIME & SCHEDULE ===
    clock: mdiClockOutline,
    clockOutline: farClock,
    history: matHistory,
    schedule: matSchedule,

    // === STATUS & INFO ===
    badge: matBadge,
    bolt: matBolt,
    browser: matOpenInBrowser,
    browserNotSupported: matBrowserNotSupported,
    contentCopy: matContentCopy,
    errorOutline: matErrorOutline,
    exclamationCircleSolid: fasExclamationCircle,
    exclamationTriangle: fasExclamationTriangle,
    fiberNew: matFiberNew,
    flag: matFlag,
    inbox: matInbox,
    info: matInfo,
    infoCircle: fasInfoCircle,
    infoOutline: evaInfoOutline,
    installMobile: matInstallMobile,
    localOffer: matLocalOffer,
    markEmailUnread: matMarkEmailUnread,
    newspaper: farNewspaper,
    orders: mdiShoppingOutline,
    question: mdiHelpCircleOutline,
    warning: matWarning,

    // === MISC ===
    angleDownSolid: fasAngleDown,
    appStore: fabAppStore,
    bugReport: matBugReport,
    fullscreen: matFullscreen,
    googlePlay: fabGooglePlay,
    percent: fasPercent,
    percentage: fasPercentage,


    stop: matStop,
    stopCircle: matStopCircle,
}

export type IconsMap = typeof ICONS

export const resolveIcon = (name: string | undefined | null) => {
    if (!name)
        return undefined
    if (name.match(/img\:/) || name.length > 20) {
        return name
    }
    return ICONS[name as keyof typeof ICONS]
}

export const resolveIconFirst = (...names: (string | undefined | null)[]) => {
    for (const name of names) {
        if (!name)
            continue;
        const value = resolveIcon(name)
        if (value) {
            return value
        }
    }
}
